import { lazy } from 'react';

const Searcher = lazy(() => import('./CustomMassiveEmail'));

export default Searcher;
